import classNames from 'classnames'
import React from 'react'
import './tooltip.scss'

export interface TooltipProps {
    text?: string
    position?: 'top' | 'bottom'
    arrowPosition?: 'left' | 'middle' | 'right'
}

export const Tooltip: React.FC<TooltipProps> = ({ text, position = 'top', arrowPosition = 'left' }) => {
    if (!text) return null
    return <div className={classNames('tooltip', position, `arrow-${arrowPosition}`)}>{text}</div>
}
